import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
  },
  destiny: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',

    '& span': {
      textTransform: 'uppercase',
      fontSize: '1rem',
      fontWeight: 600,
    },
  },
  keyboard: {
    padding: '16px 0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: '20px 20px 0 0',
    background: '#fff',
  },
  row: {
    width: '210px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  number: {
    minWidth: '60px',
    height: '60px',
    margin: '5px',
    borderRadius: '20px',
    background: '#fff',
    border: '2px solid #c4c4c4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: '#010D1F',
    fontSize: '26px',
    textTransform: 'uppercase',
    fontWeight: 600,
  },
  cancel: {
    minWidth: '60px',
    height: '60px',
    margin: '5px',
    borderRadius: '20px',
    background: '#ff0000',
    border: '1px solid #c4c4c4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    color: '#fff',
    fontSize: '10px',
    textTransform: 'uppercase',
    fontWeight: 600,
  },
  switch: {
    margin: '10px 0 16px 0',
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    width: '100%',
    height: '60px',
    background: '#4caf50',
    textTransform: 'uppercase',
    fontWeight: 600,
    color: '#fff',
  },
}));

export default useStyles;
